module.exports = __webpack_public_path__ + "static/media/icon6.935a7ef7.svg";